import { Component, Input, OnInit } from '@angular/core';
import { Roulette } from 'app/public/model/roulette.model';

@Component({
  selector: 'app-live-roulette',
  templateUrl: './live-roulette.component.html',
  styleUrls: ['./live-roulette.component.scss']
})
export class LiveRouletteComponent implements OnInit {
  @Input()
  public roulette: Roulette;
  get plateUrl() {
    return this.roulette?.Design.Spinner.PlateUrl;
  }
  get ButtonUrl() {
    return this.roulette?.Design.Spinner.ButtonUrl;
  }
  get BackgroundImageUrl() {
    this.setColors()
    return this.roulette?.Design.Spinner.BackgroundImageUrl;
  }
  get LightColor() {
    return this.roulette?.Design.Spinner.LightColor
  }
  firstSound = false;
  num: number = 0;
  animationNumber: string;
  showConfety = false;
  timeout: any;
  winSound = false;
  constructor() {
  }

  ngOnInit(): void {
    this.setColors() 
  }
  setColors() {
    document.querySelector("body").style.cssText = "--LightColor: " + this.roulette?.Design.Spinner.LightColor;
    document.querySelector("body").style.cssText += "--DarkColor: " + this.roulette?.Design.Spinner.DarkColor;
  }
  win() {
    this.firstSound = true;
    this.num = Math.round(Math.random() * 7) + 1;
    console.log("this.num " + this.num)
    this.animationNumber = null;
    this.animationNumber = "number-" + this.num;
    this.timeout = setTimeout(() => {
      this.showConfety = false;
    }, 8300);
  }
}
